import { RootState } from '..';
import { Module } from "vuex";
import { firestoreAction } from 'vuexfire'
import { db, FieldValue } from '../db';

interface Survey {
  id: string;
  questions: [];
  date: firebase.firestore.Timestamp;
}


export interface SurveysState {
  list: Survey[];
  index: {
    answered?: string[];
    surveyInfoRead?: boolean;
    words?: { 
      w: string;
      v: string[];
    }[];
    visitedWords?: string[];
  } | null;
}

const SurveysModule: Module<SurveysState, RootState> = {
  namespaced: true,
  state() {
    return {
      list: [],
      index: {
        answered: [],
        surveyInfoRead: false, 
        words: undefined,
        visitedWords: undefined
      },
    }
  },
  actions: {
    bindSurveys: firestoreAction((context) => {
      const d = new Date()
      d.setHours(d.getHours() - 2.5)
      return context.bindFirestoreRef('list', db.collection('surveys').where('date', '<', d).orderBy('date', 'desc'))
    }),
    bindSurveyIndex: firestoreAction(context => {
      return context.bindFirestoreRef('index', db.collection('surveyIndexes').doc(context.rootGetters.user.uid))
    }),
    setSurveyInfoRead: firestoreAction(context => {
      return  db
        .collection('surveyIndexes')
        .doc(context.rootGetters.user.uid)
        .set({ surveyInfoRead: true }, {merge: true})
    }),
    answerSurveyQuestion(context, payload) {
      localStorage.setItem(`lidate.survey.${payload.id}.${payload.question}`, JSON.stringify(payload.answer))
    },
    visitWord: firestoreAction((context, payload) => {
      return db
        .collection('surveyIndexes')
        .doc(context.rootGetters.user.uid)
        .set({ visitedWords: FieldValue.arrayUnion(payload) }, { merge: true })
    }),

    persistSurveyAnswers: firestoreAction((context, payload) => {
      const answers = Object
        .keys(localStorage)
        .filter(k => k.indexOf(`lidate.survey.${payload.id}`) === 0)
        .sort()
        .map(k => {
          const v = localStorage.getItem(k)
          localStorage.removeItem(k)
          if(v) {
            return JSON.parse(v)
          } else {
            return null
          }
        })

      return db
        .collection('surveyAnswers')
        .doc(payload.id)
        .collection('answers_survey')
        .doc(context.rootGetters.user.uid)
        .set({
          answers: answers,
          collected: false
        })
    })
  },
  getters: {
    words(state) {
      const visited = state.index && state.index.visitedWords ? state.index.visitedWords : []

      if(state.index && state.index.words) {
        return state.index.words.map(m => ({
          word: m.w,
          variants: m.v,
          visited: visited.includes(m.w)
        }))
      }

      return []
    },
    incompleteSurveys(state) {
      return state.list.filter((s) => {
        if (state.index && state.index.answered) {
          return state.index.answered.indexOf(s.id) === -1
        }
        return true
      })
    }
  }
}

export default SurveysModule